import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FIREARM_TYPE } from "assets-model";
import { FirearmAssignablePersonService, FirearmAssignmentLogService, FirearmPoolService, FirearmService, FirearmStorageLocationService } from "assets-service";
import { FirearmStorageAssignmentCreationDialogComponent, FirearmStorageAssignmentCreationDialogConfigData, FirearmStorageAssignmentCreationDialogData } from "./firearm-storage-assignment-creation-dialog.component";



export interface FirearmReturnDialogData extends FirearmStorageAssignmentCreationDialogData {
}

export interface FirearmReturnDialogConfigData extends FirearmStorageAssignmentCreationDialogConfigData {
}

@Component({
  selector: 'app-firearm-return-dialog',
  templateUrl: './firearm-return-dialog.component.html',
  styleUrls: ['./firearm-return-dialog.component.scss']
})
export class FirearmReturnDialogComponent extends FirearmStorageAssignmentCreationDialogComponent {

  get firearmTypeName(): string {
    return FIREARM_TYPE.typeName(this.data?.firearm);
  }

  constructor(
    dialogRef: MatDialogRef<FirearmReturnDialogComponent, FirearmReturnDialogData>,
    @Inject(MAT_DIALOG_DATA) data: FirearmReturnDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    firearmService: FirearmService,
    firearmAssignmentLogService: FirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    firearmPoolService: FirearmPoolService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, firearmService, firearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, firearmPoolService, configService, userStorage);
  }

  protected isStorageAssigneeRequired() {
    return this.currentlyIssued;
  }
  protected isLocationRequired() {
    return this.currentlyIssued;
  }
  protected isCommentRequired() {
    return this.currentlyIssued;
  }

  isFirearmReturnEnabled() {
    return this.isFirearmStorageAssignmentCreationEnabled();
  }

  firearmReturn() {
    this.firearmService.returnFirearm({
      assetId: this.data.firearm?.assetId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item.comments
    }).subscribe(result => {
      this.item.firearm = result;
      this.dialogRef.close(this.item);
    });
  }

}